import {caSetting} from "./config/ca";

export const caMoment = (moment: any) => {
    return moment.locale('ca', caSetting);
}
